import api from './api';

const adminService = {
  // Get all users with pagination and filters
  getUsers: async (params = {}) => {
    const response = await api.get('/admin/users', { params });
    return response;
  },

  // Get single user by ID
  getUserById: async (id) => {
    const response = await api.get(`/admin/users/${id}`);
    return response;
  },

  // Get user bookings with pagination and search
  getUserBookings: async (id, params = {}) => {
    const response = await api.get(`/admin/users/${id}/bookings`, { params });
    return response;
  },

  // Update user status (Active/Deactive)
  updateUserStatus: async (id, status) => {
    const response = await api.put(`/admin/users/${id}/status`, { status });
    return response;
  },

  // Update user details
  updateUser: async (id, data) => {
    const response = await api.put(`/admin/users/${id}`, data);
    return response;
  },

  // Soft delete user
  deleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response;
  },

  // Restore deleted user
  restoreUser: async (id) => {
    const response = await api.post(`/admin/users/${id}/restore`);
    return response;
  },

  // Permanently delete user
  permanentDeleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}/permanent`);
    return response;
  },

  // Change user password
  changeUserPassword: async (id, password) => {
    const response = await api.post(`/admin/users/${id}/change-password`, { password });
    return response;
  },

  // Send message to user
  sendMessageToUser: async (id, message, messageType, emailTitle) => {
    const response = await api.post(`/admin/users/${id}/send-message`, {
      message,
      message_type: messageType,
      email_title: emailTitle
    });
    return response;
  },

  // Export users to Excel (all records, with optional filters)
  exportUsersExcel: async (params = {}) => {
    const response = await api.get('/admin/users/export/excel', {
      params,
      responseType: 'blob'
    });
    return response;
  },

  // Export users to PDF (all records, with optional filters)
  exportUsersPDF: async (params = {}) => {
    const response = await api.get('/admin/users/export/pdf', { params });
    return response;
  },

  // Add Airliner
  addAirliner: async (data) => {
    const response = await api.post('/admin/users/airliner', data);
    return response;
  },

  // Add JetSetter
  addJetSetter: async (data) => {
    const response = await api.post('/admin/users/jetsetter', data);
    return response;
  },

  // Add SubAdmin
  addSubAdmin: async (data) => {
    const response = await api.post('/admin/users/subadmin', data);
    return response;
  },

  // Get SAX modules and permissions
  getModulesPermissions: async () => {
    const response = await api.get('/admin/sax/modules-permissions');
    return response;
  },

  // Get the logged-in user's own permission IDs (for sidebar/route guards)
  getMyPermissions: async () => {
    const response = await api.get('/admin/sax/my-permissions');
    return response;
  },

  // Get user-specific SAX permissions
  getUserPermissions: async (id) => {
    const response = await api.get(`/admin/sax/user-permissions/${id}`);
    return response;
  },

  // Update/Sync user-specific SAX permissions
  updateUserPermissions: async (id, permissions) => {
    const response = await api.post(`/admin/sax/update-permissions/${id}`, { permissions });
    return response;
  },

  // Get booking lifecycle timeline
  getBookingLifecycle: async (token) => {
    const response = await api.get(`/admin/bookings/lifecycle/${token}`);
    return response;
  },

  // Get booking passengers
  getBookingPassengers: async (token) => {
    const response = await api.get(`/admin/bookings/${token}/passengers`);
    return response;
  },

  // Update booking notes
  updateBookingNotes: async (token, notes) => {
    const response = await api.post(`/admin/bookings/${token}/notes`, { notes });
    return response;
  },

  // Reissue booking confirmation
  reissueBookingConfirmation: async (token) => {
    const response = await api.post(`/admin/bookings/${token}/reissue-confirmation`);
    return response;
  },

  // Get Analytics Dashboard URL
  getAnalyticsDashboard: async (source) => {
    const response = await api.get('/admin/analytics/dashboard', { params: { source } });
    return response;
  },

  // Force logout user
  forceLogoutUser: async (id) => {
    const response = await api.post(`/admin/users/${id}/force-logout`);
    return response;
  },

  // Get airliner's aircraft
  getAirlinersAircraft: async (params) => {
    const { airliner_id, ...queryParams } = params;
    const response = await api.get(`/admin/airliners/${airliner_id}/aircrafts`, { params: queryParams });
    return response;
  },

  // Get all airliners list for dropdowns (flight management, etc.)
  getAirlinersList: async () => {
    const response = await api.get('/admin/users/airliners');
    return response;
  }
};

export default adminService;
